import { isSet } from "../helpers/isset";

/**
 * Description: Initialise the vimeo player functionalities
 * 
 * @class Search
 * @typedef {Search}
 */

class Video {
    constructor(domNode) {
        this.domNode = domNode;

        window.addEventListener(
            'load',
            this.init.bind(this),
            true
        );
    }

    init(){
        this.domNode.classList.add('has-vimeo-video');
        const videoElm = document.createElement('div');
        videoElm.classList.add('vimeo-video__player-container');

        this.videoElm = videoElm;
        
        this.vimeoURL = this.domNode.getAttribute('data-vimeo-url');
        
        if(!isSet(this.vimeoURL)){
            console.warn("No Vimeo URL found on " + this.videoElm);
            return;
        }

        this.posterElm = this.domNode.querySelector("img");
        this.posterElm.classList.add('vimeo-video__poster');

        const actionElm = document.createElement('button');
        const actionIcon = document.createElement('i');
        actionElm.classList.add('vimeo-video__action');
        actionIcon.classList.add('sa-icon--play');
        actionElm.append(actionIcon);

        actionElm.addEventListener(
            'click',
            this.loadResponse.bind(this)
        );

        this.actionElm = actionElm;

        this.domNode.append(this.videoElm);
        this.domNode.append(this.actionElm);

        this.requestURL = "https://vimeo.com/api/oembed.json?url=" + this.vimeoURL;


    }

    async loadResponse(){
        try {
            const vimeoResponse = await fetch(this.requestURL);
            const vimeoJSON = await vimeoResponse.json();
            const vimeoHTML = vimeoJSON.html;

            this.videoElm.insertAdjacentHTML('beforeend' , vimeoHTML);
            this.actionElm.remove();
            if(isSet(this.posterElm)){
                this.posterElm.remove();
            }
    
        } catch (err) {
            console.error(err);
        }
    }
}

exports.Video = Video